import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer10 from "../shared/Footer10";
import Navbar10 from "../shared/Navbar10";
import Sidebar10 from "../shared/Sidebar10";
// import useSidebarToggle from "../hooks/useSidebarToggle";
import config from "../../config";
import "react-tooltip/dist/react-tooltip.css";
import { MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import { MdOutlineKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";

function DataNotFoundList() {
  // useSidebarToggle();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [studentData, setStudentData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);

  useEffect(() => {
    document.body.classList.add("sidebar-icon-only");
    return () => {
      document.body.classList.remove("sidebar-icon-only");
    };
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("tokenclassx");
    const fetchStudents = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(
          `${config.API_BASE_URL}/FetchDataNotFound_CL10`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            // body: JSON.stringify({
            //   schooL_CODE: schoolCode,
            // }),
          }
        );

        if (!response.ok) {
          // Swal.fire({
          //   icon: "warning",
          //   title: "Data not found!",
          // });
          return;
        }

        const data = await response.json();
        // console.log("Total Registration Data:", data);
        setStudentData(data.data.dataNotFound_list || []);
        // console.log(data.data["student-data"] || []);
      } catch (error) {
        console.error("Error fetching students:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStudents();
  }, []);

  const filteredStudents = studentData.filter((student) => {
    const query = searchQuery.toLowerCase();
    return (
      student.registratioN_NO?.toLowerCase().includes(query) ||
      student.candidatE_NAME?.toLowerCase().includes(query) ||
      student.gender?.toLowerCase().includes(query) ||
      student.dob?.includes(query) ||
      student.fatheR_NAME?.toLowerCase().includes(query) ||
      student.motheR_NAME?.toLowerCase().includes(query) ||
      student.aadhaR_CARD?.includes(query) ||
      student.remarks?.includes(query) ||
      student.currenT_STATUS?.toLowerCase().includes(query)
    );
  });

  const totalPages = Math.ceil(filteredStudents.length / perPage);
  const indexOfLastItem = currentPage * perPage;
  const indexOfFirstItem = indexOfLastItem - perPage;
  const currentItems = filteredStudents.slice(
    indexOfFirstItem,
    indexOfLastItem
  );
  const handlePerPageChange = (e) => {
    setPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  return (
    <div class="container-scroller">
      {isLoading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <Navbar10 />
      <div class="container-fluid page-body-wrapper">
        <Sidebar10 />
        <div class="main-panel">
          <div class="content-wrapper">
            <div class="row">
              <div class="col-md-12 mb-1">
                <section class="content-header">
                  <h1 className="text-danger">
                    <i class="fa fa-user-plus"></i>&nbsp; Status of Data Not Found
                  </h1>
                  <ol class="breadcrumb">
                    <li>
                      <a
                        href="#"
                        onClick={() => {
                          navigate("/class-x-dashboard");
                        }}
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginTop: "-4px" }}
                        >
                          <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                        </svg>{" "}
                        Home&nbsp;
                      </a>
                    </li>
                    <li class="active"> Status of Data Not Found</li>
                  </ol>
                  <h3></h3>
                </section>
              </div>
            </div>
            <div className="row" style={{ padding: "0px" }}>
              <div className="col-md-12 personal-details">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <div className="d-flex align-items-center">
                        <label htmlFor="rowsPerPage" className="me-2 mb-0">
                          Rows:
                        </label>
                        <div style={{ width: "250px" }}>
                          <select
                            id="rowsPerPage"
                            className="form-select form-select-sm"
                            value={perPage}
                            onChange={handlePerPageChange}
                            style={{
                              width: "80px", // or adjust as needed (80–120px)
                              paddingRight: "2rem", // ensures space for the dropdown arrow
                            }}
                          >
                            {[10, 20, 50, 100, 500].map((num) => (
                              <option key={num} value={num}>
                                {num}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {/* Search on the right */}
                      <div style={{ width: "200px" }}>
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                    </div>

                    {isLoading ? (
                      <p>Loading...</p>
                    ) : (
                      <div className="table-responsive">
                        <table className="table table-bordered table-striped">
                          <thead>
                            <tr className="table-info">
                              <th>Sl. No</th>
                              <th>Registration No.</th>
                              <th>Name of Candidate</th>
                              <th>Gender</th>
                              <th style={{ width: "110px" }}>Date of Birth</th>
                              <th>Father's Name</th>
                              <th>Mother's Name</th>
                              <th>Aadhaar Number</th>
                              <th>Remarks</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentItems.length === 0 ? (
                              <tr>
                                <td colSpan="9" className="text-center">
                                  No data found.
                                </td>
                              </tr>
                            ) : (
                              currentItems.map((row, index) => (
                                <tr key={index}>
                                  <td>
                                    {(currentPage - 1) * perPage + index + 1}
                                  </td>
                                  <td>{row.registratioN_NO || ""}</td>
                                  <td>{row.candidatE_NAME}</td>
                                  <td>{row.gender}</td>
                                  <td>{row.dob}</td>

                                  <td>{row.fatheR_NAME}</td>
                                  <td>{row.motheR_NAME}</td>
                                  <td>
                                    {row.aadhaR_CARD
                                      ? "********" + row.aadhaR_CARD.slice(-4)
                                      : ""}
                                  </td>
                                  <td>
                                    <label
                                      style={{ marginBottom: "3px" }}
                                      className={`badge 
    ${row.currenT_STATUS === "UNDER PROCESS" ? "badge-warning" : ""} 
    ${row.currenT_STATUS === "Resolve" ? "badge-success" : ""} 
    ${row.currenT_STATUS === "Reject" ? "badge-danger" : ""}`}
                                    >
                                      {row.currenT_STATUS}
                                    </label>{" "}
                                    <br></br>
                                    {row.remarks
                                      ? `Remarks : ${row.remarks}`
                                      : ""}
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    )}

                    <div className="d-flex justify-content-between align-items-center mt-3">
                      <div>
                        Showing {(currentPage - 1) * perPage + 1} to{" "}
                        {Math.min(indexOfLastItem, filteredStudents.length)} of{" "}
                        {filteredStudents.length} entries
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <MdOutlineKeyboardDoubleArrowLeft
                          onClick={() => {
                            if (currentPage > 1) setCurrentPage(1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardArrowLeft
                          onClick={() => {
                            if (currentPage > 1)
                              setCurrentPage((prev) => prev - 1);
                          }}
                          style={{
                            cursor: currentPage > 1 ? "pointer" : "not-allowed",
                            opacity: currentPage > 1 ? 1 : 0.5,
                          }}
                        />

                        <span>
                          Page {currentPage} of {totalPages}
                        </span>

                        <MdOutlineKeyboardArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage((prev) => prev + 1);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />

                        <MdOutlineKeyboardDoubleArrowRight
                          onClick={() => {
                            if (currentPage < totalPages)
                              setCurrentPage(totalPages);
                          }}
                          style={{
                            cursor:
                              currentPage < totalPages
                                ? "pointer"
                                : "not-allowed",
                            opacity: currentPage < totalPages ? 1 : 0.5,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Footer10 />
        </div>
      </div>
    </div>
  );
}

export default DataNotFoundList;
